import { ModalProp } from "@/types";
import { getValueByPath } from "./shared";
import { DescriptionsItemType } from "antd/es/descriptions";

export function wrapUpDescriptions(
  cols: ModalProp[],
  data: Record<string, any> | undefined,
) {
  return cols.map((one) => {
    const convertor = one.convertor;
    let value = data ? getValueByPath(data, one.key) : undefined;
    if (convertor != null) {
      value = convertor(value);
    }
    return {
      key: one.key,
      label: one.label,
      children: value,
    } as DescriptionsItemType;
  });
}
